export default __webpack_public_path__ + "static/media/customized.20f76b27.png";